<template>
  <div>
    <el-dialog class="dialog-limit" title="提示" :visible="visible" append-to-body width="576px">
      <div class="title">免费答题次数已用完</div>
      <div class="modal-content">
        {{ `开通会员即可解锁 ${questionTypeText} 无限刷题特权~` }}
      </div>
      <template v-slot:footer>
        <el-button type="default" @click="onConfirm('1')">不用了</el-button>
        <el-button type="primary" @click="onConfirm('2')">了解会员</el-button>
        <el-button type="primary" @click="onConfirm('3')">开通会员</el-button>
      </template>
    </el-dialog>
    <VipOpenModal v-model="isShow" :goBack="goBack" />
  </div>
</template>

<script>
import VipOpenModal from './VipOpenModal';
export default {
  name: 'LimitModal',
  components: {
    VipOpenModal,
  },
  props: {
    questionType: {
      type: String,
      default: '专项练习',
    },
    value: {
      type: Boolean,
      default: false,
    },
    goBack: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      visible: false,
      isShow: false,
      questionTypeText: '专项练习',
    };
  },
  watch: {
    value(value) {
      this.visible = value;
    },
    questionType: {
      immediate: true,
      handler(value) {
        this.questionTypeText = value;
      },
    },
  },
  methods: {
    checkAnswer(type, text) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve) => {
        let res = await this.$http.get('/api/app/question/checkUserAnswerCount', {
          type: type,
        });
        if (res.code == 203) {
          this.visible = true;
          this.questionTypeText = text;
          return;
        }
        resolve();
      });
    },
    cancel() {
      this.visible = false;
      this.$emit('input', false);
    },
    onConfirm(type) {
      if (type == '1') {
        this.cancel();
      } else if (type == '2') {
        this.$router.push({ name: 'Vip' });
      } else if (type == '3') {
        this.isShow = true;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.dialog-limit {
  text-align: center;
  ::v-deep {
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
    }
    .title {
      padding: 32px 0 8px 0;
      height: 24px;
      font-size: 18px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      color: #333333;
      line-height: 24px;
    }
    .modal-content {
      height: 24px;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      color: #333333;
      line-height: 24px;
      margin-bottom: 24px;
    }
    .el-dialog__footer {
      padding: 0 0 32px 0;
      text-align: center;
    }
  }
}
</style>
